import React, { useState } from "react";
import { BsStar } from "react-icons/bs";
import { FaMedal } from "react-icons/fa";
import { Loader } from "rsuite";
import { useGetAllUsersQuery } from "../../entities/User/userApi";
import style from "./LeadersBoard.module.scss";

export const LeadersBoard = () => {
	const [sortField, setSortField] = useState("firstName");
	const [sortOrder, setSortOrder] = useState("asc");

	const { data, isLoading } = useGetAllUsersQuery({ sortField, sortOrder });

	if (isLoading) {
		return <Loader center content="loading" vertical />;
	}

	const toggleSortOrder = () => {
		setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
	};

	return (
		<div className={style.leaderboard}>
			<div className={style.header}>
				<button
					type="button"
					onClick={() => {
						setSortField("firstName");
						toggleSortOrder();
					}}
					className={sortField === "firstName" ? style.active : ""}
				>
					Name
				</button>
				<button
					type="button"
					onClick={() => {
						setSortField("score");
						toggleSortOrder();
					}}
					className={sortField === "score" ? style.active : ""}
				>
					Ratings
				</button>
				<button
					type="button"
					onClick={() => {
						setSortField("followers");
						toggleSortOrder();
					}}
					className={sortField === "followers" ? style.active : ""}
				>
					Followers
				</button>
			</div>

			<div className={style.leaderList}>
				{data?.map((leader, index) => (
					<div className={style.leaderRow} key={leader._id}>
						<div className={style.rank}>
							{index <= 3 ? (
								<FaMedal
									style={{
										color:
											index === 0
												? "#FFD700"
												: index === 1
													? "#C0C0C0"
													: "#CD7F32",
									}}
								/>
							) : (
								<span>{index + 1}</span>
							)}
						</div>
						<div className={style.userInfo}>
							<img
								src={`https://ui-avatars.com/api/?name=${leader.firstName}+${leader.lastName}`}
								alt={leader?.firstName}
								className={style?.avatar}
							/>
							<div>
								<div className={style.name}>{leader?.firstName}</div>
								<div className={style.title}>{leader?.lastName}</div>
							</div>
						</div>
						<div className={style.stats}>
							<BsStar /> {leader?.score}
						</div>
						<button type="button" className={style.followBtn}>
							Follow
						</button>
					</div>
				))}
			</div>
		</div>
	);
};
